import { render, staticRenderFns } from "./ProductAdvantagesList.vue?vue&type=template&id=248fd1a5&scoped=true"
import script from "./ProductAdvantagesList.vue?vue&type=script&lang=js"
export * from "./ProductAdvantagesList.vue?vue&type=script&lang=js"
import style0 from "./ProductAdvantagesList.vue?vue&type=style&index=0&id=248fd1a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248fd1a5",
  null
  
)

export default component.exports